module.exports = __webpack_public_path__ + "static/langojango-serbian-language-phrasebook-23ce1be154a3f37ff8a6b1cca33d5370.png";